import { useGate } from '@hotjar/allowances';
import { useFeatureFlag } from '@hotjar/feature-flags';
import { RecordingLink } from '@hotjar/feedback/components/common/RecordingLink';
import { ContentsquareReplayLink } from '@hotjar/feedback/components/common/ContentsquareReplayLink';
import type { Context } from '@hotjar/allowances/src/types';

const CONTENTSQUARE_REPLAY_FLAG = 'feedback.contentsquare_replay';

export type SurveyRecordingProps = {
  recordingUrl: string | null;
  contentsquareUrl: string | null;
  coveragePercentage: number;
  siteId?: number;
  type: 'icon' | 'button';
  trackUiPosition: string;
};

export const SurveyRecording = ({
  recordingUrl,
  coveragePercentage,
  contentsquareUrl,
  siteId,
  type,
  trackUiPosition,
}: SurveyRecordingProps): JSX.Element | null => {
  const context: Context = { id: String(siteId), type: 'site' };

  const hasContentsquareFF = useFeatureFlag(CONTENTSQUARE_REPLAY_FLAG);
  const hasContentsquareGate = useGate(CONTENTSQUARE_REPLAY_FLAG, context);

  const hasContentsquareReplay = hasContentsquareFF || hasContentsquareGate === true;

  if (hasContentsquareReplay && contentsquareUrl !== null) {
    return (
      <ContentsquareReplayLink
        url={contentsquareUrl}
        type={type}
        trackUiPosition={trackUiPosition}
      />
    );
  }

  return (
    <RecordingLink
      url={recordingUrl}
      opener="survey-response"
      type={type}
      trackTriggerView="survey.responses"
      trackUiPosition={trackUiPosition}
      coveragePercentage={coveragePercentage}
      outlinedIcon
    />
  );
};
